
<template>

  <b-modal
    ref="modal"
    id="agPasswordModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="changeButton_clicked">
    <template slot="modal-header">
      <h4 class="agModal-title">Change Password</h4>
    </template>
    <b-input-group size="md" prepend="Current Password">
      <b-input type="password" v-model="oldPassword" autocomplete="false" :state="hasError('oldPassword')"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="New Password">
      <b-input type="password" v-model="newPassword" autocomplete="false" :state="hasError('newPassword')"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Retype New Password">
      <b-input type="password" v-model="retypePassword" autocomplete="false" :state="hasError('retypePassword')"></b-input>
    </b-input-group>
    <hr>
    <label v-if="errorMessage" class="agModal-message agModal-errorMessage">{{errorMessage}}</label>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-button class="agModal-buttonRight" variant="primary" @click="changeButton_clicked">Change</b-button>
    </template>
  </b-modal>
    
</template>






<script>

// components


// modules


export default {
    name: "ag-password-modal",
    components: {

    },
    props:{
        
    },
    data(){
        return {
            errorMessage: "",
            errorField: "",
            oldPassword: "",
            newPassword: "",
            retypePassword: ""
        };
    },
    computed: {

    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

      // UI Events

      async changeButton_clicked()
      {
          if(!this.validate()) {
            return;
          }

          var result = await this.$store.dispatch("userStore/changePassword", {oldPassword:this.oldPassword, newPassword:this.newPassword});
          if(result.data.success) {
            this.hide();
          }
          else {
            if(result.data.error.indexOf("password") > -1)
              this.errorField = "oldPassword";
            this.errorMessage = result.data.error;
          }
      },


      // emitted Events


      // other

      show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);      
        },

      hide() {
        this.$refs.modal.hide();
      },

        reset() {
        this.errorMessage = "";
        this.errorField = "";
        this.oldPassword = "";
        this.newPassword =  "";
        this.retypePassword = "";
      },


      hasError(field)
      {
        if(field == this.errorField)
        {
            return false; // false = error
        }
        return null;
      },

      validate() {
        this.modalMessage = "";
        this.modalMessageClass = "";
        this.errorField = "";

        // validate fields
        if(!this.oldPassword)
        {
          this.errorMessage = "Current password is required";
          this.errorField = "username";
          return false;
        }
        if(!this.newPassword)
        {
          this.errorMessage = "New password is required";
          this.errorField = "newPassword";
          return false;
        }
        if(!this.retypePassword)
        {
          this.errorMessage = "Retyping password is required";
          this.errorField = "retypePassword";
          return false;
        }
        if(this.newPassword != this.retypePassword) {
          this.errorMessage = "Passwords do not match";
          this.errorField = "retypePassword";
          return false;
        }

        return true;
      }
    }
}

</script>






<style scoped lang="css">

</style>



// WEBPACK FOOTER //
// src/components/user/PasswordModal.vue